import cn from 'classnames'
import Image from 'next/image'
import type { FC } from 'react'

import s from './Avatar.module.css'

interface AvatarProps {
  className?: string
  name?: string | undefined
  avatarUrl?: string | undefined
  size?: 'xsmall' | 'small' | 'medium' | 'large'
  noBackground?: boolean
}

const getInitial = (name: string | undefined): string | null => {
  let initial = '?'
  if (name && name.length > 0) {
    initial = name.charAt(0)
  }
  return initial.toUpperCase()
}

const Avatar: FC<AvatarProps> = ({
  className,
  name,
  avatarUrl,
  size = 'small',
  noBackground,
}) => {
  const initial = getInitial(name)
  const char = initial?.charCodeAt(0) || -1
  return (
    <div
      className={cn(
        className,
        'select-none overflow-hidden rounded-full transition duration-100',
        {
          'bg-neutral-100': !noBackground,
          'h-4 w-4': size === 'xsmall',
          'h-5 w-5': size === 'small',
          'h-6 w-6': size === 'medium',
          'h-7 w-7': size === 'large',
        }
      )}
    >
      {avatarUrl ? (
        <Image
          className={cn('object-cover object-center', {
            'h-4 w-4': size === 'xsmall',
            'h-5 w-5': size === 'small',
            'h-6 w-6': size === 'medium',
            'h-7 w-7': size === 'large',
          })}
          src={avatarUrl}
          alt={name || ''}
          width={32}
          height={32}
          quality={85}
        />
      ) : (
        <div
          className={cn(
            'w-fullrounded flex items-center justify-center bg-gradient-to-br text-white',
            {
              'h-4 w-4': size === 'xsmall',
              'h-5 w-5': size === 'small',
              'h-6 w-6': size === 'medium',
              'h-7 w-7': size === 'large',
              'text-xs': size === 'small',
              'text-sm': size !== 'small',
              [s.red]: char < 70,
              [s.purple]: 70 <= char && char < 75,
              [s.yellow]: 75 <= char && char < 80,
              [s.green]: 80 <= char && char < 85,
              [s.blue]: 85 <= char && char < 90,
              [s.cyan]: char >= 90,
            }
          )}
        >
          {initial}
        </div>
      )}
    </div>
  )
}

export default Avatar
